module.exports = __webpack_public_path__ + "img/Collectioncode.49eb5111.png";